import NewsDetailScreen from "@/src/screens/news/news-detail-screen/news-detail-screen";

export default function NewsDetail() {
  return <NewsDetailScreen />;
}
